import "./ModalityDropdown.css"

export default function ModaityDropdown({modality_checkboxes, set_modality_checkboxes}){

    const checkboxClickHandler = (modaity) => {
        if (!modality_checkboxes.includes(modaity)) set_modality_checkboxes([...modality_checkboxes, modaity])
        else set_modality_checkboxes(modality_checkboxes.filter(mode => mode != modaity))
    }

    return (
        <div className="modalities-container">
            <ul className="modalities-list">
                <li onClick={() => checkboxClickHandler("Written")} > 
                    <span className="modality-option-text"> Written </span>  
                    <span className="modality-option-emogi"> ✏️ </span>  
                    <label className="modalities-checkbox">
                        <input type="checkbox" className="checkbox-button-modality"
                            checked={modality_checkboxes.includes("Written")}
                        />
                    </label>
                </li>
                <li onClick={() => checkboxClickHandler("MCQ")}> 
                    <span className="modality-option-text"> MCQ </span>  
                    <span className="modality-option-emogi"> 🔠 </span>  
                    <label className="modalities-checkbox">
                        <input type="checkbox" className="checkbox-button-modality"
                            checked={modality_checkboxes.includes("MCQ")}
                        />
                    </label>
                </li>
                <li onClick={() => checkboxClickHandler("Code")}> 
                    <span className="modality-option-text"> Code </span> 
                    <span className="modality-option-emogi"> 🖥️ </span> 
                    <label className="modalities-checkbox">
                        <input type="checkbox" className="checkbox-button-modality"
                            checked={modality_checkboxes.includes("Code")}    
                        />
                    </label>
                </li>
            </ul>
        </div>
    );
}